import React from 'react';
import { Route, Link, routeHistory } from '@nackle/biw-web-router';
import { UnsavedChangesModal } from '@nackle/studio-tools';
import { routes, bundleRoutingMiddleware } from './app-routing';
import auth, { authRouteMiddleware, authRequestMiddleware } from './auth';
import { applyRequestMiddleware } from '../hatch/utils/fetch';
import { AppHeader, AppError } from '@nackle/studio-tools';
import { Layout, Result } from 'antd';
const { Content } = Layout;
import { Bridge } from '@nackle/bridge';
import './app.less';

/**
 * This component acts as a consumer of the hatch.
 */
export default function App() {

    const handleCompanyChange = ( company ) => {
        routeHistory.push( `/${ company.id }` );
    };

    return (
        <AppError>
            <Route render={ ( route ) => {
                // set the title
                document.title = route && route.match ? route.match.title : 'Home';

                const companyId = route.state?.params?.companyId;

                return (
                    <Bridge
                        auth={ auth }
                    >
                        <Layout className="root-layout">
                            <AppHeader
                                auth={ auth }
                                companyId={ companyId }
                                onCompanyChange={ handleCompanyChange }
                            />
                            <Layout className="page-layout">
                                <Content key={ companyId } className="app-content">
                                    {
                                        route.match ?
                                            React.cloneElement( route.component, { companyId, auth } )
                                            : (
                                                <Result
                                                    status="404"
                                                    title="404"
                                                    subTitle="Sorry, the page you visited does not exist."
                                                    extra={ <Link to="/" className="ant-btn ant-btn-primary">Back Home</Link> }
                                                />
                                            )
                                    }
                                </Content>
                            </Layout>
                        </Layout>
                    </Bridge>
                );
            } } />
        </AppError>
    );
}

// Connect Routing
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( [ authRouteMiddleware, UnsavedChangesModal.routerMiddleware, bundleRoutingMiddleware ] );

// Connect Auth to Fetch
applyRequestMiddleware( authRequestMiddleware );
